import { PatriotToolsIndexScreen } from "@src/features/patriot-tools";

export default PatriotToolsIndexScreen;
